'use client'
import Script from 'next/script'

const OneTrust = () => {
  return (
    <>
      <Script
        data-document-language='true'
        data-domain-script='0195297c-31d9-7a1f-9d93-60eebbbca5a0'
        src='https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
        strategy='afterInteractive'
        onLoad={() => {
          // console.log('OneTrust External script loaded successfully!')
          function OptanonWrapper() {}
        }}
        onError={(e) => {
          console.error('Error loading external script:', e)
        }}
      />
    </>
  )
}

export default OneTrust
